var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2827 6.50657C15.2827 9.13557 13.1514 11.2668 10.5224 11.2668C7.89344 11.2668 5.76221 9.13557 5.76221 6.50657C5.76221 3.87757 7.89344 1.74634 10.5224 1.74634C13.1514 1.74634 15.2827 3.87757 15.2827 6.50657Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.043 22.5564C20.043 26.2291 15.7806 29.2223 10.5205 29.2223C5.26034 29.2223 1 26.2372 1 22.5564C1 18.8755 5.26238 15.8925 10.5225 15.8925C15.7826 15.8925 20.043 18.8755 20.043 22.5564Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2707 10.9505C24.2707 12.5282 22.9918 13.8071 21.4142 13.8071C19.8365 13.8071 18.5576 12.5282 18.5576 10.9505C18.5576 9.37291 19.8365 8.09399 21.4142 8.09399C22.1718 8.09399 22.8983 8.39495 23.434 8.93066C23.9698 9.46636 24.2707 10.1929 24.2707 10.9505Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-36",
    d: "M22.7632 27.3187C25.6478 27.5556 28.4769 25.461 28.4763 22.5565C28.4757 19.6524 25.6471 17.5593 22.7632 17.7962",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-19",
    d: "M35.0079 1C35.0079 0.530558 34.6273 0.15 34.1579 0.15C33.6884 0.15 33.3079 0.530558 33.3079 1H35.0079ZM33.3079 5.96947C33.3079 6.43891 33.6884 6.81947 34.1579 6.81947C34.6273 6.81947 35.0079 6.43891 35.0079 5.96947H33.3079ZM35.0079 5.9695C35.0079 5.50006 34.6273 5.1195 34.1579 5.1195C33.6884 5.1195 33.3079 5.50006 33.3079 5.9695H35.0079ZM33.3079 10.939C33.3079 11.4084 33.6884 11.789 34.1579 11.789C34.6273 11.789 35.0079 11.4084 35.0079 10.939H33.3079ZM34.1579 6.81953C34.6274 6.81953 35.0079 6.43897 35.0079 5.96953C35.0079 5.50009 34.6274 5.11953 34.1579 5.11953V6.81953ZM29.1885 5.11953C28.719 5.11953 28.3385 5.50009 28.3385 5.96953C28.3385 6.43897 28.719 6.81953 29.1885 6.81953V5.11953ZM34.158 5.11953C33.6885 5.11953 33.308 5.50009 33.308 5.96953C33.308 6.43897 33.6885 6.81953 34.158 6.81953V5.11953ZM39.1274 6.81953C39.5969 6.81953 39.9774 6.43897 39.9774 5.96953C39.9774 5.50009 39.5969 5.11953 39.1274 5.11953V6.81953ZM33.3079 1V5.96947H35.0079V1H33.3079ZM33.3079 5.9695V10.939H35.0079V5.9695H33.3079ZM34.1579 5.11953H29.1885V6.81953H34.1579V5.11953ZM34.158 6.81953H39.1274V5.11953H34.158V6.81953Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPeople);
export default __webpack_public_path__ + "static/media/addPeople.ed2204d5445c0e82ac72b86838cc5f00.svg";
export { ForwardRef as ReactComponent };